// auth/KeycloakContext.js
import { createContext, useContext } from "react"

export const KeycloakContext = createContext(null)

export const useKeycloak = () => {
  const kc = useContext(KeycloakContext)
  if (!kc) throw new Error("useKeycloak must be used inside KcWrapper")
  return kc
}
